import { observer } from 'mobx-react';
import * as React from 'react';
import * as classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { IGalleryPicture } from './../../../../../common/interfaces/picture';
import { computed, observable, reaction } from 'mobx';

// Styles
const s = require('./PortalItemPicture.css');
const cancelIcon = require('./../../../assets/cross-orange-sign.svg');

// Props
interface IPortalItemPictureProps {
    onClose: () => void;
    images: IGalleryPicture[];
}

// Component
@observer
export class PortalItemPicture extends React.Component<IPortalItemPictureProps, {}> {

    private enterTransitionTime = 800;
    private leaveTransitionTime = 800;

    private reactToShowChange = reaction(
        () => this.show,
        (show: boolean) => {
            if (show) {
                this.hiding = false;
            } else {
                this.hiding = true;
                setTimeout(() => {
                    if (this.hiding) {
                        this.hiding = false;
                    }
                }, this.leaveTransitionTime);
            }
        }
    );

    @computed private get show(): boolean {
        return this.props.images.length > 0;
    }

    @observable private hiding: boolean = false;

    public render() {
        const { images } = this.props;

        return (
            <CSSTransitionGroup
                onClick={this.handleCloseGallery}
                component="div"
                className={classNames(s.gallery, {
                    [s.show]: this.show,
                    [s.hiding]: this.hiding
                })}
                transitionName="gallery-group"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={this.enterTransitionTime}
                transitionEnterTimeout={this.enterTransitionTime}
                transitionLeaveTimeout={this.leaveTransitionTime}
            >
                {images.map((image) => (
                    <div key={image.full} className={s.image}>
                        {(image.thumb) && (
                            <div
                                key={image.thumb}
                                className={classNames(s.img, s.thumb)}
                                style={{ backgroundImage: 'url(' + image.thumb + ')' }}
                            />
                        )}
                        {(image.full) && (
                            <div
                                key={image.full}
                                className={classNames(s.img, s.full)}
                                style={{ backgroundImage: 'url(' + image.full + ')' }}
                            />
                        )}
                    </div>
                ))}

                <button key="close-button" className={s.closeButton} onClick={this.handleCloseGallery}>
                    <i>
                        <img src={cancelIcon} alt="" />
                    </i>
                </button>
            </CSSTransitionGroup>
        );
    }

    private handleCloseGallery = () => {
        this.props.onClose();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalPicture/PortalItemPicture.tsx